import React from 'react'
import './NavBar.css'
/** redux */
import { connect } from 'react-redux'
import { logoutRequest } from '../../redux/actions/authActions'

import { Navbar, Nav, NavDropdown } from 'react-bootstrap'
import  ithLogo  from '../../assets/images/ith-logo.png'
import tecnmLogo from '../../assets/images/tecnm-logo-circle.png'


const NavBar = ({ auth, logoutRequest }) => {
  const { user } = auth;
  const handlerLogout = () => {
    'inscrito' in user
    ? logoutRequest('student', '/aspirantes/login')
    : logoutRequest('staff', '/admin/login')
  }
  return (
    <>
        <Navbar bg="dark" variant="dark" className='d-flex justify-content-between nav'>
          <div> </div>
          <img alt="ith" src={ithLogo} style={{ width: '50px', height: '50px'}} />
          <Navbar.Brand href="#home"> <h3>ITH</h3> </Navbar.Brand>
          <img alt="tecnm" src={tecnmLogo} style={{ width: '50px', height: '50px'}} />
          <Nav>
              <NavDropdown title={user.full_name} id="collasible-nav-dropdown" alignRight>
                  <NavDropdown.Item href="#action/3.2">Mi perfil</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item  onClick={handlerLogout} >Cerrar sesion</NavDropdown.Item>
              </NavDropdown>
          </Nav>
      </Navbar>
  </>
  )
}

const mapDispatchToProps = (state) => ({
  auth: state.auth
})

const dispatchStateToProps = {
  logoutRequest
}

export default connect( mapDispatchToProps, dispatchStateToProps )(NavBar)